import { render, staticRenderFns } from "./Forward.vue?vue&type=template&id=0896082c&"
import script from "./Forward.vue?vue&type=script&lang=js&"
export * from "./Forward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports